import { useDispatch, useSelector } from 'react-redux';
import useNavigation from '../../../hook/useNavigation';
import useScroll from '../../../hook/useScroll';
import { ArrowLeftIcon, HeartIcon } from '@heroicons/react/24/outline';
import { encodeValue, logError, sendAnalyticsCustomEvent, trackMetaPixelEvent } from '../../../utils/helper';
import { handleFavorite, handleGetStoreDetail } from '../../../store/reducers/outlet';
import { uniqueID } from '../../../utils/constants';
import Type from 'ufood-x/components/Header/Type';

const Header = () => {
	const dispatch = useDispatch();
	const navigate = useNavigation();
	const { isScrolled } = useScroll();
	const user = useSelector((store) => store?.user);
	const { details: outlet } = useSelector((store) => store?.outlet);

	const handleClickFavorite = () => {
		const dataFavoritePost = {
			unquieid: uniqueID,
			shopID: encodeValue(outlet?.storeID),
			customerID: encodeValue(user?.customerID),
		};

		const dataGetStoreDetail = {
			storeID: outlet?.storeSlug,
			latitude: user?.latitude,
			longitude: user?.longitude,
		};

		const eventName = isFavorite ? 'homepage_unfavorite' : 'homepage_favorite';
		sendAnalyticsCustomEvent(eventName, {
			customer_id: user?.customerID,
			...outlet,
		});

		dispatch(handleFavorite({ isFavorite, dataFavoritePost }))
			.unwrap()
			.then((res) => {
				if (res?.status === 'ok') {
					dispatch(handleGetStoreDetail(dataGetStoreDetail));
					trackMetaPixelEvent(eventName, {
						customer_id: user?.customerID,
						favorite_items: [
							{
								favorite_id: res?.data?.fav_id,
								merchants_id: outlet?.storeID,
								merchants_name: outlet?.storeName,
								merchants_distance: `${outlet?.distance} KM`,
								merchants_rating: outlet?.rating,
							},
						],
					});
				}
			})
			.catch((error) => {
				logError(error, { feature: 'handleFavorite' });
			});
	};

	const isFavorite = Boolean(Number(outlet?.favorite || outlet?.favourite));

	return (
		<div
			className={`fixed top-0 right-0 left-1/2 -translate-x-1/2 w-full max-w-lg transition-all duration-300 ease-in-out z-[1] 
        ${isScrolled ? 'bg-white shadow-md' : 'bg-transparent'}
      `}>
			<div className='w-full max-w-lg mx-auto px-4 py-4'>
				<div className='flex flex-row justify-between items-center'>
					<div className='flex justify-center items-center cursor-pointer' onClick={() => navigate.push('/')} id='merchant_back'>
						<ArrowLeftIcon className={`h-8 w-8 transition-all duration-300 ${isScrolled ? 'text-gray-900 p-1' : 'text-gray-900 bg-white rounded-full p-1.5 shadow-md'}`} />
					</div>
					<div className={`flex-1 px-2 min-w-0 transition-all duration-300 ${isScrolled ? 'opacity-100 transform translate-y-0' : 'opacity-0 transform -translate-y-2'}`}>
						<h1 className='text-left text-gray-900 text-base font-semibold truncate max-w-[75vw]'>{outlet?.storeName}</h1>
					</div>
					<div className={`pr-2 ${!user?.is_b2b ? 'hidden' : ''}`}>
						<Type />
					</div>
					<div className={`flex justify-center items-center cursor-pointer ${!user?.customerID && 'hidden'}`} onClick={handleClickFavorite} id={isFavorite ? 'merchant_unfavorite_outlet' : 'merchant_favorite_outlet'}>
						<HeartIcon className={`h-8 w-8 transition-all duration-300 bg-white rounded-full ${isFavorite ? `fill-red-500 text-red-500 p-1` : `text-gray-900 ${isScrolled ? 'p-1' : 'p-1.5 shadow-md'}`}`} />
					</div>
				</div>
			</div>
		</div>
	);
};

export default Header;
